<template>
  <Modal :size="ModalSize.MD" :height="ModalHeight.AUTO" open persistent>
    <template #content>
      <div class="px-12 py-10 flex flex-col gap-8">
        <div class="flex flex-col gap-4 items-center">
          <Icon :icon="CupSvg" :size="IconSize['2XL']" class="text-success" />

          <h2 class="text-xl font-bold text-on-surface">
            {{ props.hub.congratulationsPopupHeadline }}
          </h2>

          <p class="text-on-surface">
            {{ props.hub.congratulationsPopupBody }}
          </p>
        </div>

        <div
          v-if="
            props.hub.displayCongratulationsPopupCtaButton &&
            props.hub.congratulationsPopupCtaButtonUrl
          "
          class="flex gap-6 justify-center"
        >
          <Btn
            :size="BtnSize.LG"
            :color="BtnColor.SECONDARY"
            @click="redirectToHub"
          >
            {{ t('common.cancel') }}
          </Btn>
          <Btn
            :size="BtnSize.LG"
            :variant="BtnVariant.FILLED"
            :color="BtnColor.PRIMARY"
            :to="props.hub.congratulationsPopupCtaButtonUrl"
            target="_blank"
            @click="redirectToHub"
          >
            {{ props.hub.congratulationsPopupCtaButtonText }}
          </Btn>
        </div>
        <div v-else class="text-center">
          <Btn
            :size="BtnSize.LG"
            :color="BtnColor.SECONDARY"
            @click="redirectToHub"
          >
            {{ t('common.close') }}
          </Btn>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Btn, BtnColor, BtnSize, BtnVariant } from '~/components/btn';
import { Icon, IconSize } from '~/components/icon';
import CupSvg from '~/assets/icons/cup.svg?component';

import { Modal, ModalSize } from '~/components/modals/modal';
import { HubDto } from '~/api/hubs';
import { ModalHeight } from '~/components/modals/modal/modal.constants';

type Props = {
  hub: HubDto;
};
const props = defineProps<Props>();

const { t } = useI18n();

const redirectToHub = () => {
  navigateTo(`/${props.hub.slug}`);
};
</script>
